module.exports = __webpack_public_path__ + "img/3-2.7f93cc49.jpg";